module.exports = __webpack_public_path__ + "880d7b8ad7d70a1cb9e208901fc373d7.jpg";